/**
 * Format date string to localized format
 * @param {string} dateString - Date string to format
 * @param {string} locale - Locale for formatting (default: 'en-IN')
 * @param {object} options - Intl.DateTimeFormat options
 * @returns {string} Formatted date string
 */
export const formatDate = (
  dateString,
  locale = "en-IN",
  options = {
    year: "numeric",
    month: "short",
    day: "numeric",
  },
) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleDateString(locale, options);
};

export const isValidDateRange = (
  fromDate,
  toDate,
  allowFutureDates = false,
) => {
  const now = new Date();

  // Must be valid Date objects
  if (!(fromDate instanceof Date) || isNaN(fromDate)) return false;
  if (!(toDate instanceof Date) || isNaN(toDate)) return false;

  // Must not be future dates
  if (fromDate.getTime() > now.getTime()) return allowFutureDates;
  if (toDate.getTime() > now.getTime()) return allowFutureDates;

  // From date must be <= To date
  if (fromDate.getTime() > toDate.getTime()) return false;

  return true;
};

export const formatDateToYYYYMMDD = (dateString) => {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

export const formatDate_DD_MM_YYYY = (date) => {
  if (!(date instanceof Date) || isNaN(date)) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};

export const getOneMonthBack = (date = new Date()) => {
  const d = new Date(date);

  // Prevent month overflow issues (31st → Feb)
  const day = d.getDate();
  d.setDate(1);
  d.setMonth(d.getMonth() - 1);
  d.setDate(
    Math.min(day, new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()),
  );

  return d;
};

export const formatDateToISOstring = (date = new Date()) => {
  return date.toISOString();
};
